/**
 * For more info about ETOE services,
 * https://stamps.atlassian.net/wiki/spaces/PRODREQ/pages/3122988/Web+Client+-+Support+for+ETOE
 */
import PackageType from './PackageType.enum';
import ServiceType from './ServiceType.enum';

export default Object.freeze({
	[ServiceType.UspsFirstClassMailIntl]: {
		serviceName: 'Postal Economy International',
		serviceTitle: 'Postal Economy International (Varies)',
		serviceTypeDescription:
			'Postal Economy International is an inexpensive way to mail and ship internationally.',
		packages: {
			[PackageType.LargeEnvelope]: {
				packageName: "Economy Int'l Large Envelope/Flat",
				packageTitle: 'Postal Economy International Large Envelope/Flat',
				packageDescription:
					'Send mail using your own large envelope or flat with pricing that varies by weight and country.',
				packageRequirements: [
					'Min Dimensions: Must be more than 11 1/2&quot; long, or more than 6 1/8&quot;, or more than 1/4&quot; thick.',
					'Max Dimensions: 15&quot; x 12&quot; x 3/4&quot;',
				],
			},
			[PackageType.Package]: {
				packageName: "Economy Int'l Package/Thick Envelope",
				packageTitle: 'Postal Economy International Package/Thick Envelope',
				packageDescription:
					'Ship up to 4 lbs. and $400 worth of merchandise using your own box with pricing that varies by weight and country.',
				packageRequirements: [
					'Length + width + height cannot exceed 36&quot;.',
					'Length cannot exceed 24&quot;.',
				],
			},
		},
	},
	[ServiceType.UspsPriorityMailIntl]: {
		serviceName: 'Postal Priority International',
		serviceTitle: 'Postal Priority International (6 - 10 Days)',
		serviceTypeDescription:
			'Postal Priority International is a fast, affordable way to ship internationally.',
		packages: {
			[PackageType.Package]: {
				packageName: "Priority Int'l Package/Flat/Thick Envelope",
				packageTitle:
					'Postal Priority International Package/Flat/Thick Envelope',
				packageDescription:
					'Ship up to 70 lbs. using any flat, thick envelope, or box with pricing that varies by weight and country.<br /><br />Tip: This service includes free insurance of up to $100 for documents and $200 for merchandise.',
				packageRequirements: [
					'Min Dimensions: Shipping label must completely fit on a single side',
					'Max Dimensions: Length + 2x width + 2x height cannot exceed 108&quot; (some countries have further restrictions)',
				],
			},
		},
	},
	[ServiceType.UspsPriorityMailExpressIntl]: {
		serviceName: 'Postal Express International',
		serviceTitle: 'Postal Express International (3 - 5 Days)',
		serviceTypeDescription:
			'Postal Express International is a faster, premium way to ship internationally.',
		packages: {
			[PackageType.Package]: {
				packageName: "Express Int'l Package/Flat/Thick Envelope",
				packageTitle:
					'Postal Express International Package/Flat/Thick Envelope',
				packageDescription:
					'Ship up to 70 lbs. using any flat, thick envelope, or box with pricing that varies by weight and country.<br /><br />Tip: This service includes free insurance of up to $100 for documents and $200 for merchandise.',
				packageRequirements: [
					'Min Dimensions: Shipping label must completely fit on a single side',
					'Max Dimensions: Length + 2x width + 2x height cannot exceed 108&quot; (some countries have further restrictions)',
				],
			},
		},
	},
});
